export default "__VITE_ASSET__BCG7MFmP__"